import { initArchiveFitHeading } from './archive_fit_heading';

export function initCompanyArchiveFitHeading(root = document) {
  initArchiveFitHeading(root, {
    headingSelector: '.js-company-archive-fit-h1',
    lineSelector: '.js-company-archive-fit-line',
  });
}
